import React from 'react';
import Header from '../components/header';
import Footer from '../components/footer';
import "../styles/components/aPropos.scss";

const APropos = () => {
  return (
    <div>
      <Header/>
    <header className="header_a-propos">
      <h1>À PROPOS</h1>
      <h1>FIM</h1>
      <p>Est une plateforme dédiée aux passionnés de cinéma et de télévision, offrant une expérience immersive pour explorer,</p>
      <p>découvrir et se connecter avec les films et séries préférés.</p>
      <p>Avec une vaste base de données comprenant des informations détaillées sur des milliers de productions, acteurs et réalisateurs,</p>
      <p><strong>F I M</strong> est l'endroit idéal pour trouver le dernier blockbuster,</p>
      <p>redécouvrir un classique ou explorer de nouvelles séries captivantes. Son interface intuitive et sa navigation fluide permettent aux utilisateurs</p>
      <p>d'explorer facilement le catalogue, lire des critiques,</p>
      <p>suivre les actualités du cinéma et créer des listes de visionnage personnalisées.</p>
      <p>Rejoignez la communauté dynamique de <strong>F I M</strong> et plongez dans un univers cinématographique riche et diversifié. Que vous soyez un cinéphile passionné ou un spectateur occasionnel,</p>
      <p><strong>F I M</strong> vous offre tous les outils nécessaires pour vivre pleinement votre passion pour le cinéma et la télévision.</p>
      <div className="etudiant">
        <div className="row">
          <div className="d-flex justify-content-center col-md-12 col-lg-4 col-xl-3">
            <img src="/a-propos/Fahed Bougamra.jpg" alt="photo-Fahd-Bougamra" />
          </div>
          <div className="align-items-center col-md-12 col-lg-8 col-xl-9">
            <h1>FAHED BOUGAMRA</h1>
            <p>Passionné par le développement web et en fin de formation en Techniques de développement Web, il est motivé par la création de solutions innovantes et fonctionnelles.
              Avec une solide expérience en gestion d'entreprises, il a développé un sens aigu de l'organisation, de la prise de décision et du leadership.</p>
            <p>Sa transition vers le développement web est animée par une forte volonté d'exploiter ses compétences techniques en HTML, CSS, JavaScript
              et plusieurs autres technologies, ainsi que sa capacité à travailler en équipe et à résoudre des problèmes complexes.
              Son expérience antérieure en gestion de projets lui a inculqué un souci du détail et une rigueur qu'il souhaite appliquer dans le
              domaine du développement web.</p>
            <p>Il est un professionnel polyvalent, capable de s'adapter rapidement à de nouveaux défis et de travailler efficacement sous pression.
              Ses compétences en gestion de projets, communication et relation client, combinées à ses connaissances techniques,
              lui permettent de contribuer de manière significative à tout projet de développement web.</p>
          </div>
        </div>
      </div>
    </header>
    <Footer/>
    </div>
  );
};

export default APropos;
